<template>
  <div id="app">
    <a-modal :width="800" v-model="visible" :footer="null" @cancel="visible=false" class="parcel_modal">
      <div class="modal_view">
        <div class="textarea">
          <div id="showDiv0" class="showDiv0" :style="{top: scrollHigh+21+'px'}">
            <div v-for="(item,i) in indexList">
              {{ i + 1 }}
            </div>
          </div>
          <a-textarea
            @scroll="textScroll($event)"
            v-model="textValue"
            onfocus="focus()"
            placeholder="Please enter your Printbelle tracking number (starting with PB) Multiple numbers shoud be separated by comma, space or enter">
          </a-textarea>
          <div id="showDiv1" class="showDiv1" :style="{top: scrollHigh+14+'px'}">
            <div v-for="(item,i) in indexList" @click="clearSingle(i)">
              <a-icon type="close"/>
            </div>
          </div>
          <div class="numLimit">
            <span style="margin-right: 10px;cursor: pointer" @click="clearAll()"
                  v-if="indexList.length>0">Clear all</span>
            <span>{{ indexList.length }}/50</span>
          </div>
        </div>
        <div class="btn" @click="searchValue(1)">
          <a-icon type="search" style="font-size: 25px;margin-right: 6px"/>
          Track
        </div>
      </div>
    </a-modal>
    <div class="container">
      <header>
        <div class="logo_view">
          <img src="../assets/logo.png" alt="logo" @click="toHome" style="width: 41px;height: 41px">
          <img src="../assets/logo1.png" alt="logo" @click="toHome" style="width: 144px;height: 22px">
          <span>Fulfillment</span>
        </div>
        <a-tabs :default-active-key="activeKey"
                v-model="activeKey"
                @change="callback"
                :tabBarStyle="{ borderBottom: 'unset' }">
          <a-tab-pane
            v-for="item in types"
            :key="item.key"
            :tab="item.name">
          </a-tab-pane>
        </a-tabs>
        <div class="login_btn">
          <img src="../assets/login.png" style="width: 30px;height: 30px"/>
          <span @click="goLogin()">Login</span>
        </div>
      </header>
      <main>
        <div class="tracking">
          <div class="tracking_view" @scroll="handleScroll($event)">
            <div class="searchBox">
              <div class="searchTitle">
                <div class="numer"><em>{{ originalList.length }}</em>
                  /50
                </div>
                <a class="hint" @click="goLogin()">Login to track up to 500 shipments</a>
              </div>
              <div style="display: flex;width: 774px;margin: 0 auto">
                <div class="search" style="width: 654px; height: 65px;margin: 26px auto;background: #C8C3F9">
                  <div class="leftDiv" style="width: 516px">
                    <a-input
                      v-model="inputValue"
                      @click="setVisible()"
                      onfocus="blur()"
                      autocomplete="off"
                      placeholder="Please enter your Printbelle tracking number (starting with PB)."/>
                  </div>
                  <div class="rightDiv" style="width: 138px">
                    <div class="btn" @click="searchValue(0)" style="font-size: 23px">
                      <a-icon type="search" style="font-size: 23px;margin-right: 6px"/>
                      Track
                    </div>
                  </div>
                  <p @click="LastQuery" v-if="cacheContent!==null"
                     style="font-size: 14px; height: 20px; position: absolute; bottom: -45px; left: 15px; font-family: Arial, Helvetica, sans-serif; cursor: pointer;">
                <span
                  style="background: #152235; color: rgb(255, 255, 255); border-radius: 15px; padding: 3px 15px;">
                  {{ getCacheContent() }}
                </span>
                  </p>
                </div>
                <div class="search" style="width: 110px;height: 65px;margin: 26px auto;background: #C8C3F9">
                  <img src="../assets/track1.jpg" @click="goToTrack()"
                       style="margin: 8px auto;cursor: pointer;border-radius: 32px"/>
                </div>
              </div>
            </div>
            <div :class="scroll>190?'tabs_scroll':'tabs'">
              <div class="tabs_view">
                <a-radio-group v-model="status" @change="changeTab">
                  <a-radio-button
                    v-for="item in shipTypes"
                    :key="item.key"
                    :value="item.name">
                    {{ item.name + '(' + item.count + ')' }}
                  </a-radio-button>
                </a-radio-group>
                <a-dropdown>
                  <template #overlay>
                    <a-menu @click="handleExport">
                      <a-menu-item key="1">
                        Copy Summary
                      </a-menu-item>
                      <a-menu-item key="2">
                        Copy Details
                      </a-menu-item>
                      <a-menu-item key="3">
                        Export Summary
                      </a-menu-item>
                    </a-menu>
                  </template>
                  <a-button type="primary" size="small">
                    Copy & Export
                    <a-icon type="caret-down"/>
                  </a-button>
                </a-dropdown>
              </div>
            </div>
            <div class="banner" v-if="isBanner">
              <a-icon class="close" type="close-circle" @click="closeBanner"/>
              <a-carousel autoplay>
                <div @click="openAboutUs"><img src="../assets/banner1.jpg"/></div>
                <div v-if="false"><img src="../assets/banner2.png"/></div>
              </a-carousel>
            </div>
            <a-table
              class="table"
              :defaultExpandedRowKeys="[-1]"
              :expandIconAsCell="false"
              :loading="loading"
              :expandIconColumnIndex="-1"
              :row-key="(record) => record.trackNumber"
              :columns="columns"
              :customRow="rowClick"
              @expand="onExpand"
              :rowClassName="rowClassName"
              :expandedRowKeys="expandedRowKeys"
              expandRowByClick
              :data-source="nowList"
              :pagination="false">
              <template slot="Last Mile Tracking">
                <div style="display: flex; align-items: center;">
                  <div
                    style="width: 6px; height: 6px; background: #FFB400; border-radius: 50%; margin-right: 5px;"></div>
                  <div>Last Mile Tracking&nbsp;&nbsp;</div>
                </div>
                <div style="display: flex; align-items: center;">
                  <div
                    style="width: 6px; height: 6px; background: #C091FE; border-radius: 50%; margin-right: 5px;"></div>
                  <div>Order Number</div>
                </div>
              </template>

              <span slot="trackNumber" slot-scope="text, record">
                <span>{{ record.trackNumber }}&nbsp;
                  <a-icon type="copy" v-show="record.isShow" @click.stop="tCopyContent(record.trackNumber)"/>
                </span>
                <br>
                <span>CN → {{ record.toCountryCode }}</span>
              </span>
              <span slot="service" slot-scope="text, record">
                  THPHR - (Printbelle Registered  Standard General)
              </span>
              <span slot="status" slot-scope="text, record">
               <a-tag :color="record.status | statusFilter(0)">
                  {{ record.status |statusFilter(1) }}
               </a-tag>
              </span>
              <span slot="orderNo" slot-scope="text, record">
               <div style="display: flex; align-items: center;">
                  <div
                    style="width: 6px; height: 6px; background: #FFB400; border-radius: 50%; margin-right: 5px;"></div>
                  <div>{{ record.agentWaybillNo || 'N/A' }}&nbsp;
                    <a-icon type="copy" v-show="record.isShow&&record.agentWaybillNo"
                            @click.stop="tCopyContent(record.agentWaybillNo)"/>
                  </div>
                </div>
                <div style="display: flex; align-items: center;">
                  <div
                    style="width: 6px; height: 6px; background: #C091FE; border-radius: 50%; margin-right: 5px;"></div>
                  <div>{{ record.orderNo }}&nbsp;
                    <a-icon type="copy" v-show="record.isShow" @click.stop="tCopyContent(record.orderNo)"/>
                  </div>
                </div>
              </span>
              <span slot="LastEvent" slot-scope="text, record" class="record_item">
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>{{
                        record.trackInfo ? record.trackInfo[0].checkpointDate + '' + record.trackInfo[0].trackingDetail : ''
                      }}</span>
                  </template>
                  {{
                    record.trackInfo ? record.trackInfo[0].checkpointDate + '' + record.trackInfo[0].trackingDetail : ''
                  }}
                </a-tooltip>
              </span>
              <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                <div class="row_title">
                  <a-icon type="copy"/>
                  <a href="javascript:" @click="tCopyContent(getDetails([record]))">Copy Details</a>
                  <a-icon type="copy" style="margin-left: 40px"/>
                  <a href="javascript:" @click="tCopyContent(getLink(record))">Copy Link</a>
                </div>
                <div class="roe_list">
                  <div class="list_l">
                    <div class="item" v-for="(item,index) in record.trackInfo">
                      <div class="item_view">
                        <span class="week">{{ weekDay(item.checkpointDate, 0) }}</span>
                        <span class="date">{{ weekDay(item.checkpointDate, 1) }}</span>
                        <span class="week">{{ weekDay(item.checkpointDate, 2) }}</span>
                      </div>
                      <div class="item_line">
                        <img src="../assets/aircraft.png" style="width: 20px;height: 21px" v-if="index===0"/>
                        <img src="../assets/cloud.png" style="width: 16px;height: 12px" v-else/>
                        <a-divider class="divider" type="vertical" dashed
                                   v-if="index !== (record.trackInfo.length-1) "/>
                      </div>
                      <span class="des">{{ item.trackingDetail }}</span>
                    </div>
                  </div>
                  <div class="list_r">
                    <div class="info_box">
                      Shipment Information
                    </div>
                    <div class="info_view">
                      Order Number
                      <span>{{ record.orderNo }}</span>
                      Country
                      <span>CN → {{ record.toCountryCode }}</span>
                    </div>
                    <div class="info_box">
                      Additional Notes
                    </div>
                    <div class="info_view">
                      <span>Distributor:USPS Distributor</span>
                      <span>Website:http://www.usps.com</span>
                      <span>Contact Number:1-800-275-8777</span>
                    </div>
                  </div>
                </div>

              </div>
            </a-table>
          </div>

        </div>
      </main>

    </div>
  </div>
</template>

<script>
import {tCopyContent} from '../utils/utils'
import merge from 'webpack-merge'
import XLSX from 'xlsx'

export default {
  name: 'Index',
  data () {
    return {
      loading: false,
      visible: false,
      isShow: false,
      isBanner: true,
      isExpand: false,
      selectIndex: null,
      scroll: 0,
      scrollHigh: 0,
      activeKey: 1,
      textValue: '',
      indexList: [],
      inputValue: '',
      cacheContent: '',
      nowList: [],
      originalList: [],
      contentList: [],
      expandedRowKeys: [],
      status: 'All',
      columns: [
        {
          title: 'Tracking Number(0d/0d)',
          dataIndex: 'trackNumber',
          ellipsis: true,
          scopedSlots: {customRender: 'trackNumber'},
        },
        {
          title: 'Delivery Status',
          dataIndex: 'status',
          ellipsis: true,
          width: '140px',
          scopedSlots: {customRender: 'status'},
        },
        {
          slots: {title: 'Last Mile Tracking'},
          dataIndex: 'orderNo',
          ellipsis: true,
          scopedSlots: {customRender: 'orderNo'},
        },
        {
          title: 'Service',
          dataIndex: 'service',
          width: '220px',
          scopedSlots: {customRender: 'service'},
        },
        {
          title: 'Last Event',
          dataIndex: 'LastEvent',
          scopedSlots: {customRender: 'LastEvent'},
        },
      ],
      types: [
        {
          key: 0,
          name: 'Home',
        },
        {
          key: 1,
          name: 'Parcel Tracking',
        }
      ],
      shipTypes: [
        {
          key: 0,
          name: 'All',
          count: 0,
        },
        {
          key: 1,
          name: 'Processing',
          count: 0,
        },
        {
          key: 2,
          name: 'Transit',
          count: 0,
        },
        {
          key: 3,
          name: 'Delivered',
          count: 0,
        },
        {
          key: 4,
          name: 'Not Found',
          count: 0,
        },
        {
          key: 5,
          name: 'Alert',
          count: 0,
        },
        {
          key: 6,
          name: 'Exception',
          count: 0,
        },
      ],
    }
  },
  filters: {
    statusFilter (status, type) {
      switch (status) {
        case 'pending':
        case 'InfoReceived':
          return type === 0 ? 'blue' : 'Processing'
        case 'transit':
        case 'pickup':
          return type === 0 ? 'orange' : 'Transit'
        case 'delivered':
          return type === 0 ? 'lime' : 'Delivered'
        case 'notfound':
          return type === 0 ? 'purple' : 'Not Found'
        case 'undelivered':
        case 'expired':
          return type === 0 ? 'geekblue' : 'Alert'
        case 'exception':
          return type === 0 ? 'red' : 'Exception'
      }
    },
  },
  computed: {},
  mounted () {
    document.body.style.overflowY = 'hidden'
  },
  created () {
    let queryType = this.$route.params.type || 1
    let ids = this.$route.query.id || ''
    this.inputValue = ids
    this.textValue = ids
    this.isBanner = true
    if (ids === '') return
    if (queryType === 1) {
      this.searchValue(0)
    } else if (queryType === 2) {
      this.LastQuery()
    }
  },
  methods: {

    tCopyContent,
    async getInfo (val) {
      const map = new Map()
      let values = val.split(',')
      let value = values.filter(key => !map.has(key) && map.set(key, 1)).join(',')
      this.contentList = value.split(/[\n,' ]/).filter(val => val !== '')
      this.indexList = this.contentList
      this.inputValue = value
      this.textValue = value
      this.$router.push({query: merge(this.$route.query, {'id': value})}).catch(res => {
      })
      localStorage.setItem('cacheContent', value)
      const {...params} = {id: value}
      this.loading = true
      this.$http({method: 'get', url: '/api/tracking/v1', params: params}).then((res) => {
        this.loading = false
        if (res.data.code === 200) {
          const resList = res.data.data
          this.shipTypes.forEach(item => {
            let list = []
            switch (item.name) {
              case 'All':
                return item.count = resList.length
              case 'Processing':
                list = resList.filter(item => item.status === 'pending' || item.status === 'InfoReceived')
                return item.count = list.length
              case 'Transit':
                list = resList.filter(item => item.status === 'transit' || item.status === 'pickup')
                return item.count = list.length
              case 'Delivered':
                list = resList.filter(item => item.status === 'delivered')
                return item.count = list.length
              case 'Not Found':
                list = resList.filter(item => item.status === 'notfound')
                return item.count = list.length
              case 'Alert':
                list = resList.filter(item => item.status === 'undelivered' || item.status === 'expired')
                return item.count = list.length
              case 'Exception':
                list = resList.filter(item => item.status === 'exception')
                return item.count = list.length
            }

          })
          resList.forEach(item => {
            item['isShow'] = false
            item['serverCode'] = 'THPHR'
            item['serverName'] = 'Printbelle Registered Standard General'

          })
          this.nowList = resList
          this.originalList = resList
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    textScroll (event) {
      let el = event.target
      this.scrollHigh = -el.scrollTop
    },
    handleScroll (event) {
      let el = event.target
      this.scroll = el.scrollTop
    },
    getCacheContent () {
      let content = []
      this.cacheContent = localStorage.getItem('cacheContent')
      if (this.cacheContent != null) {
        content = this.cacheContent.split(',')
      }
      return content.length === 1 ? content[0] : 'Last query record'
    },
    toHome () {
      this.$router.push({name: 'AboutUs'})
    },
    callback () {
      this.$router.push({name: 'Index'})
    },
    goToTrack () {
      window.open('https://www.17track.net/?utm_medium=logistics&utm_source=PB速递', '_blank')
    },
    goLogin () {
      window.open('https://www.printbelle.com/', '_blank')
    },
    searchValue (type) {
      let empty = type === 0 ? this.inputValue : this.textValue
      if (empty === '') {
        return this.$message.error('Please enter your tracking number.')
      }

      let inputValue = this.textValue.replace(/\n/g, ',')
      let contentList = inputValue.split(/[\n,' ]/).filter(val => val !== '')
      if (contentList.length > 50) {
        return this.$message.error('A maximum of 50 numbers allowed per time.')
      }
      let number = 0
      contentList.forEach((item, index) => {
        if (item.length > 50) {
          number = index + 1
        }
      })
      if (number > 0) {
        this.indexList = contentList
        return this.$message.error(`The${number} line is longer than 50 characters`)
      }
      this.inputValue = inputValue
      this.contentList = contentList
      localStorage.setItem('cacheContent', this.inputValue)
      this.cacheContent = localStorage.getItem('cacheContent')
      this.visible = false
      this.getInfo(this.inputValue)
    },
    LastQuery () {
      this.cacheContent = localStorage.getItem('cacheContent')
      this.contentList = this.cacheContent.split(/[\n,' ]/).filter(val => val !== '')
      this.inputValue = this.cacheContent
      this.textValue = this.cacheContent
      this.getInfo(this.cacheContent)
    },
    changeTab () {
      switch (this.status) {
        case 'All':
          return this.nowList = this.originalList
        case 'Processing':
          return this.nowList = this.originalList.filter(item => item.status === 'pending' || item.status === 'InfoReceived')
        case 'Transit':
          return this.nowList = this.originalList.filter(item => item.status === 'transit' || item.status === 'pickup')
        case 'Delivered':
          return this.nowList = this.originalList.filter(item => item.status === 'delivered')
        case 'Not Found':
          return this.nowList = this.originalList.filter(item => item.status === 'notfound')
        case 'Alert':
          return this.nowList = this.originalList.filter(item => item.status === 'undelivered' || item.status === 'expired')
        case 'Exception':
          return this.nowList = this.originalList.filter(item => item.status === 'exception')
      }

    },
    rowClassName (record, index) {
      return index === this.selectIndex && this.isExpand ? 'active' : ''
    },
    rowClick (record, index) {
      return {
        on: {
          mouseenter: () => {//鼠标移入行
            record.isShow = true
          },
          mouseleave: () => {//鼠标移出行
            record.isShow = false
          },
          click: () => {
            this.selectIndex = index
          }
        }
      }
    },
    onExpand (expanded, record) {
      this.isExpand = expanded
      // 只展开一行
      if (this.expandedRowKeys.length > 0) { //进这个判断说明当前已经有展开的了
        //返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        let index = this.expandedRowKeys.indexOf(record.trackNumber)
        if (index > -1) { //如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1)
        } else {
          //如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
          this.expandedRowKeys.push(record.trackNumber)
        }
      } else {
        //数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(record.trackNumber)
      }
    },
    weekDay (val, type) {
      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      let month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let today = new Date(val)
      if (type === 0) {
        return days[today.getDay()]
      } else if (type === 1) {
        return month[today.getMonth() + 1] + ',' + today.getDate() + ',' + today.getFullYear()
      } else if (type === 2) {
        return val.slice(-8) + ' Local time'
      }
    },
    closeBanner () {
      this.isBanner = false
    },
    openAboutUs () {
      this.$router.push({name: 'AboutUs'})
    },
    setVisible () {
      if (this.inputValue !== undefined) {
        let replace = this.inputValue.replace(/,/g, '\n')
        this.textValue = replace
      }
      this.indexList = [...this.contentList]
      this.visible = true

    },
    clearAll () {
      this.indexList = []
      this.textValue = ''
    },
    clearSingle (i) {
      this.indexList.splice(i, 1)
      this.textValue = this.indexList.join(',').replace(/,/g, '\n')
      this.contentList = this.inputValue.split(/[\n,' ]/).filter(val => val !== '')
    },
    handleExport (row) {
      if (row.key === '1') {
        this.tCopyContent(this.getContent(this.nowList))
      } else if (row.key === '2') {
        this.tCopyContent(this.getDetails(this.nowList))
      } else if (row.key === '3') {
        this.exportExcel()
      }

    },
    getContent (objList) {
      let person = ''
      objList.forEach((item, index) => {
        item['\n\nDivide'] = '\n\n'
        Object.keys(item).map((key) => {
          if (key === 'trackInfo') {
            person += item.trackInfo[0].checkpointDate + '\u0020' + item.trackInfo[0].trackingDetail
          } else {
            let placeholder = '\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020'
            if (key === 'isShow') return
            person += item[key] + (key === '\n\nDivide' ? '' : placeholder)
          }
        })
      })
      return person
    },
    getLink (record) {
      let link = process.env.NODE_ENV === 'production' ? 'http://logistic.printbelle.com' : `http://${require('ip').address()}:${8080}`
      return `${link}/Track/Detailing?id=${record.trackNumber}`
    },
    getDetails (objList) {
      let person = ''
      objList.forEach((item, index) => {
        item['\n\nDivide'] = '====================================================' + '\n\n'
        Object.keys(item).map((key) => {
          if (key === 'trackInfo') {
            Object.keys(key).map((onKey) => {
              person += onKey + ':' + item.trackInfo[onKey].checkpointDate + '&nbsp;' + item.trackInfo[onKey].trackingDetail + '\n'
            })
          } else {
            if (key === 'isShow') return
            person += key + ':' + item[key] + '\n' // 获取到属性对应的值，做一些处理
          }

        })
      })
      return person
    },
    //导出
    exportExcel () {
      // 创建工作簿
      const workbook = XLSX.utils.book_new()
      let list = []
      let titles = ['Tracking number', 'Order Number', 'Last Mile Tracking', 'Service Code', 'Serverce Name', 'Country', 'Last Event', 'Delivery Status']
      list.push(titles)
      this.nowList.forEach(item => {
        let contents = []
        contents[0] = item.trackNumber
        contents[1] = item.orderNo
        contents[2] = item.agentWaybillNo
        contents[3] = item.serverCode
        contents[4] = item.serverName
        contents[5] = 'CN->' + item.toCountryCode
        contents[6] = item.trackInfo[0].checkpointDate + item.trackInfo[0].trackingDetail
        contents[7] = item.status
        list.push(contents)
      })
      // 创建工作表
      const worksheet = XLSX.utils.aoa_to_sheet(list)

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      // 导出文档
      const wbout = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const blob = new Blob([wbout], {type: 'application/octet-stream'})
      const date = new Date()
      var year = date.getFullYear()  //获取年份
      var month = date.getMonth() + 1  //获取月份
      var day = date.getDate()  //获取日期
      var hours = date.getHours()  //获取小时
      var minutes = date.getMinutes()  //获取分钟
      var seconds = date.getSeconds()  //获取秒钟
      let name = year + '-' + month + '-' + day + ' ' + hours + '_' + minutes + '_' + seconds
      const fileName = `Tracking Results ${name}.xlsx`

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // 兼容IE浏览器
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        // 非IE浏览器
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName
        link.click()
        window.URL.revokeObjectURL(url)
      }
    },
  },

  beforeDestroy () {
    document.body.style.overflowY = 'visible'
  },
}
</script>


<style lang="less">

.parcel_modal {
  .ant-modal-wrap {
    top: 0;
  }

  .ant-modal-body {
    padding: 10px;
    background: #9bbdb4;
    border-radius: 5px;
  }

}

.active td {
  background: #761FEB !important;
  color: #FFFFFF;
}

.modal_view {
  display: flex;
  height: 303px;
  align-items: flex-end;

  .textarea {
    width: 620px;
    height: 100%;
    overflow: hidden;
    position: relative;

    .ant-input {
      height: 303px;
      max-height: 303px;
      min-height: 303px;
      padding: 20px 70px 30px 38px;
      font-size: 14px;
      line-height: 30px;
      font-weight: bold;
    }

    .showDiv0 {
      left: 0;
      top: 21px;
      width: 35px;
      height: 30px;
      list-style: none;
      text-align: center;
      font-size: 14px;
      line-height: 30px;
      font-weight: bold;
      position: absolute;
      z-index: 10;
    }

    .showDiv1 {
      width: 12px;
      padding-top: 7px;
      list-style: none;
      font-size: 14px;
      line-height: 30px;
      font-weight: bold;
      position: absolute;
      right: 45px;
      top: 14px;
    }

    .numLimit {
      position: absolute;
      bottom: 10px;
      right: 25px;
      font-weight: 500;
      font-size: 16px;
      color: #999;
    }

  }


  .btn {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 65px;
    cursor: pointer;
    font-size: 26px;
    font-family: Humanst521 BT;
    font-weight: bold;
    color: #FFFFFF;
    background: linear-gradient(135deg, #FFBF0B, #EF8201);
    border-radius: 0 5px 5px 0;
  }
}

.container {
  width: 100%;
  height: 100%;

  header {
    display: flex;
    align-items: center;
    position: fixed;
    width: 100%;
    min-width: 1900px;
    top: 0;
    left: 0;
    justify-content: space-between;
    height: 70px;
    width: 100%;
    padding: 0 47px;
    background-color: #152235;

    .logo_view {
      width: 395px;
      display: flex;
      height: 70px;
      align-items: center;

      img {
        margin-right: 18px;
      }

      span {
        font-size: 17px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #C9C8C8;
        margin-left: 50px;
      }
    }

    .login_btn {
      width: 395px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: right;
      height: 70px;

      span {
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        font-weight: bold;
        margin-left: 10px;
        color: #C9C8C8;
      }
    }

    .ant-tabs-ink-bar {
      background-color: transparent;
    }

    .ant-tabs-bar {
      margin: 0;
    }

    .ant-tabs-tab {
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
    }

    .ant-tabs-tab-active {
      color: #FFB400;
    }

    .ant-tabs-tab:hover {
      color: #FFB400;
    }
  }

  main {
    .search {
      width: 775px;
      height: 94px;
      margin-top: 35px;
      background: #7B63F1;
      position: relative;
      border-radius: 47px;

      .leftDiv {
        float: left;
        height: 100%;
        width: 615px;
        padding: 8px 0 8px 10px;
        position: relative;
        overflow: hidden;

        .ant-input {
          height: 100%;
          font-size: 16px;
          color: #929292;
          padding-left: 30px;
          background: #FFFFFF;
          box-shadow: 0 4px 3px 0 rgba(74, 74, 74, 0.2);
          border-radius: 38px 0 0 38px;
        }
      }

      .rightDiv {
        width: 160px;
        height: 100%;
        padding: 8px 10px 8px 0;
        float: right;
        position: relative;

        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          cursor: pointer;
          font-size: 26px;
          font-family: Humanst521 BT;
          font-weight: bold;
          color: #FFFFFF;
          background: linear-gradient(135deg, #FFBF0B, #EF8201);
          border-radius: 0 38px 38px 0;
        }
      }

      .track_view {
        width: 93px;
        height: 48px;
        display: flex;
        align-items: center;
        background: #FFFFFF;
        margin: 8px auto;
        box-shadow: 0px 4px 3px 0px rgba(74, 74, 74, 0.2);
        border-radius: 24px;
      }
    }

    .tracking {
      width: 100%;
      height: 100vh;
      overflow-y: hidden;
      font-family: Arial, Helvetica, sans-serif;

      .tracking_view {
        overflow-y: auto;
        height: 100%;
        margin-top: 70px;

        .ant-radio-button-wrapper {
          margin-right: 20px;
          border: 1px solid transparent;
          font-size: 16px;
          font-weight: 800;
          color: #606060;
        }

        .ant-radio-button-wrapper-checked {
          background-color: #FFF7E5;
          color: #FFB400;
          border: 1px solid #fdd77f;
        }

        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
          box-shadow: -1px 0 0 0 #FFF7E5;
        }

        .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
          background-color: #FFF7E5;
        }

        .ant-radio-button-wrapper-checked:not(:first-child)::before {
          background-color: #FFF7E5;
        }

        .ant-radio-button-wrapper:not(:first-child)::before {
          background-color: transparent;
        }

        .searchBox {
          width: 100%;
          padding-top: 20px;
          margin: 0 auto;
          height: 198px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          position: relative;
          background-color: #fff;

          .ant-input {
            font-size: 14px;
          }

          .searchTitle {
            width: 1200px;
            margin: 0 auto;
            position: relative;
            height: 40px;

            .numer {

              height: 40px;
              color: #606060;
              font-weight: 500;
              font-size: 20px;
              float: left;

              em {
                font-size: 26px;
                font-family: OPPOSans;
                font-weight: bold;
                font-style: italic;
                color: #761FEB;
              }
            }

            .hint {
              position: relative;
              top: 50%;
              cursor: pointer;
              float: left;
              margin-left: 20px;
              margin-top: -11px;
              height: 22px;
              line-height: 22px;
              width: 220px;
              background: #761FEB;
              border-radius: 30px;
              font-weight: 500;
              color: #fff;
              font-size: 12px;
              text-align: center;
            }
          }
        }

        .tabs {
          width: 100%;
          position: static;
          display: flex;
          height: 70px;
          box-shadow: rgb(239, 239, 239) 0px -1px 10px;
          top: 70px;
        }

        .tabs_scroll {
          width: 100%;
          height: 70px;
          position: fixed;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #FFFFFF;
          z-index: 2;
          padding-right: 15px;
          box-shadow: rgb(102, 102, 102) 0px -1px 6px;
          top: 70px;
        }

        .tabs_view {
          width: 1200px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .ant-btn-primary {
            padding: 0 15px;
            height: 37px;
            border: none;
            background: linear-gradient(135deg, #FFBF0B, #EF8201);
            box-shadow: 0px 3px 3px 0px rgba(74, 74, 74, 0.22);
            border-radius: 19px;
          }
        }

        .banner {
          width: 1200px;
          margin: 0 auto;
          padding-bottom: 1.6rem;
          position: relative;

          .close {
            position: absolute;
            right: 8px;
            color: #FFFFFF;
            z-index: 1;
            top: 6px;
          }
        }

        .table {
          width: 1200px;
          margin: 0 auto;
          padding-bottom: 80px;

          .ant-table-thead {
            background: #ECE3F8;
          }

          .ant-table-thead > tr > th {
            background: #ECE3F8;
            color: #606060;
          }

          .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
            background: #761FEB;
            color: #FFFFFF;
          }

          .ant-table-row-expand-icon {
            color: #606060;
          }

          .record_item {
            display: block;
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }

          .row_title {
            font-size: 14px;
            font-family: OPPOSans;
            font-weight: 500;
            margin-bottom: 10px;
            text-decoration: underline;
            color: #010101;

            a {
              color: #010101;
              text-decoration: underline;
            }

          }

          .roe_list {
            display: flex;


            .list_l {
              width: 850px;

              .item:last-child {
                border-bottom: 1px solid transparent;
                padding-top: 16px;
                height: 82px;
              }

              .item {
                display: flex;
                align-items: center;
                height: 100px;
                border-bottom: 1px solid #E5E5E5;

                .item_view {
                  width: 170px;
                  display: flex;
                  flex-direction: column;

                  .week {
                    font-size: 15px;
                    font-family: OPPOSans;
                    font-weight: 400;
                    color: #000000;
                  }

                  .date {
                    font-size: 16px;
                    font-family: OPPOSans;
                    line-height: 28px;
                    font-weight: bold;
                    color: #000000;
                  }
                }

                .item_line {
                  margin: 0 70px;
                  position: relative;

                  .ant-divider {
                    height: 80px;
                    border-width: 0 0 0 2px;
                    color: #C9C9C9;
                    position: absolute;
                    left: -1px;
                    top: 20px;
                  }

                }

                .des {
                  flex: 1;
                  display: block;
                  font-size: 13px;
                  font-family: OPPOSans;
                  font-weight: 400;
                  color: #000000;
                  margin-right: 70px;
                  overflow: hidden;
                  -webkit-line-clamp: 2;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                }
              }
            }

            .list_r {
              flex: auto;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-left: 5px;
              padding-top: 116px;
              border-left: 1px solid #E5E5E5;

              .info_box {
                width: 268px;
                height: 43px;
                line-height: 43px;
                margin-top: 10px;
                margin-left: 16px;
                background: #F1E8FD;
                text-align: center;
                border-radius: 10px;
                font-size: 16px;
                font-family: OPPOSans;
                font-weight: 800;
                color: #761FEB;
              }

              .info_view {
                width: 226px;
                display: flex;
                flex-direction: column;
                margin: 16px 0;
                font-size: 14px;
                font-family: OPPOSans;
                font-weight: bold;
                color: #000000;
                line-height: 34px;

                span {
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 24px;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/ParcelTracking.vue